export function transformFormSchema(schema) {
    const config = schema?.configuration;
    if (!config) return;

    traverseElements(config, transformElement);
}

function traverseElements(root, callback) {
    const queue = [root];

    while (queue.length) {
        const element = queue.pop();

        callback(element);

        const elements = element.elements;

        if (Array.isArray(elements)) {
            queue.push(...elements);
        }
    }
}

function transformElement(element) {
    const validators = element.validators;

    if (!Array.isArray(validators)) return;

    validators.forEach(validator => {
        if (validator.identifier === 'RequiredIf') {
            validator.type = 'required';
        }
    })
}